import { LocationGroup } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'location-group';

export class LocationGroupController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  /**
   * @param includeSubDomains when `true`, the response also contains location
   * groups owned by subdomains of the current domain. Only list/search pages
   * should request subdomain groups. Entry pages must offer groups owned by
   * the current domain only.
   */
  async findAll(includeSubDomains = false): Promise<LocationGroup[]> {
    const response = await this.http.get<LocationGroup[]>('', {
      params: { includeSubDomains },
    });
    return response.data.map((val) => new LocationGroup(val));
  }

  async findAllVisible(): Promise<LocationGroup[]> {
    const response = await this.http.get<LocationGroup[]>('visible');
    return response.data.map((val) => new LocationGroup(val));
  }

  async save(group: Partial<LocationGroup>): Promise<LocationGroup> {
    const response = await this.http.post<LocationGroup>('', group);
    return new LocationGroup(response.data);
  }
}
